export enum SubSelectionType {
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
}
